module.exports = __webpack_public_path__ + "img/lianmeng.d12c99fb.png";